module.exports = __webpack_public_path__ + "img/ic_activity_like.5e677bde.svg";